// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aJ34_jIgGAxymSO_WLx4 {
    font-weight: 100;
}

.DKYf_PrzsPvc3mK4TRVc {
    font-weight: 600;
}

.rn5mNT6zr6AByzws16ge {
    font-weight: bold;
}

.K4py5PzdI3DX39t5d6Bk {
    font-style: italic;
    font-weight: 100;
}
`, "",{"version":3,"sources":["webpack://./src/components/text/index.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".light {\n    font-weight: 100;\n}\n\n.emphasis {\n    font-weight: 600;\n}\n\n.heavy {\n    font-weight: bold;\n}\n\n.note {\n    font-style: italic;\n    font-weight: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `aJ34_jIgGAxymSO_WLx4`,
	"emphasis": `DKYf_PrzsPvc3mK4TRVc`,
	"heavy": `rn5mNT6zr6AByzws16ge`,
	"note": `K4py5PzdI3DX39t5d6Bk`
};
export default ___CSS_LOADER_EXPORT___;
